/* eslint-disable @typescript-eslint/no-explicit-any */
import {Context, FC, useContext, useMemo} from 'react'
import {ID} from '../../../../_metronic/helpers'

type Props = {
  id: ID
  context: Context<any>
}

const SelectionCell: FC<Props> = ({id, context}) => {
  const {selected, onSelect, disabled} = useContext(context)
  const isSelected = useMemo(() => selected.includes(id), [id, selected])

  const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault() // Prevent default checkbox behavior
    onSelect(id, e.shiftKey) // Pass the shift key state
  }

  const onChange = () => {}

  return (
    <div className='form-check form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        style={{border: '1px solid #6d6d80'}}
        type='checkbox'
        data-kt-check={isSelected}
        data-kt-check-target='#kt_table_users .form-check-input'
        checked={isSelected}
        // onChange={() => onSelect(id)}
        onMouseDown={handleMouseDown}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  )
}

export {SelectionCell}
